export function setData(state, payload) {
    state.data = payload;
}

export function setForm(state, payload) {
    state.form = {
        id: payload && payload.id ? payload.id : null,
        line_id: payload && payload.line_id ? payload.line_id : null,
        code: payload && payload.code ? payload.code : "",
        description: payload && payload.description ? payload.description : "",
        commission_percentage:
            payload &&
            payload.commission_percentage !== undefined &&
            payload.commission_percentage !== null
                ? payload.commission_percentage
                : null,
        commission_value:
            payload &&
            payload.commission_value !== undefined &&
            payload.commission_value !== null
                ? payload.commission_value
                : null
    };
}

export function resetForm(state) {
    state.form = {
        id: null,
        line_id: null,
        code: "",
        description: "",
        commission_percentage: null,
        commission_value: null
    };
}

export function setLoading(state, payload) {
    state.loading = payload;
}

export function setSaving(state, payload) {
    state.saving = payload;
}

export function setDeleting(state, payload) {
    state.deleting = payload;
}



// WEBPACK FOOTER //
// ./src/modules/sublinesb/mutations.js